import bus from "./bus";

export default {
    init() {

    },
    success(e) {
        e.success = true;
        bus.trigger("toast", e);
    },
    fail(e) {
        e.success = false;
        bus.trigger("toast", e);
    }
};


// WEBPACK FOOTER //
// ./src/public_app/api/toaster.js